import { actionGenerator } from '../../utils/redux/actionGenerator';

export const SET_MODAL_OPEN = 'CONSULTATION_REQUEST/SET_MODAL_OPEN';

export const setModalOpen = actionGenerator<typeof SET_MODAL_OPEN, boolean>(SET_MODAL_OPEN);

export type TSetModalOpen = ReturnType<typeof setModalOpen>;
